import { Product } from '../types/product';
import { CartItem } from '../context/CartContext';
import { getApiUrl } from '../config/api';

export const fetchProducts = async (): Promise<Product[]> => {
  try {
    const url = getApiUrl('stripe_products.php');
    console.log('Fetching products from:', url);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP error response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseText = await response.text();
    console.log('Raw response:', responseText.substring(0, 200) + '...');

    // Check if response is HTML instead of JSON
    if (responseText.trim().startsWith('<!DOCTYPE') || responseText.trim().startsWith('<html')) {
      throw new Error('Server returned HTML instead of JSON. Please check if the PHP server is running on the correct port.');
    }

    const products: Product[] = JSON.parse(responseText);
    console.log('Successfully parsed products:', products.length);
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    // @ts-ignore
    if (error instanceof SyntaxError && typeof responseText !== 'undefined') {
      // @ts-ignore
      console.error('Failed to parse JSON. Raw response:', responseText);
    }
    return [];
  }
};

export const getSubscriptionProducts = (products: Product[]): Product[] => {
  return products.filter(product => product.isSubscription);
};

export const getProductsByCategory = (products: Product[], category: string): Product[] => {
  return products.filter(product =>
    product.category?.toLowerCase() === category.toLowerCase()
  );
};

/**
 * Check if a product is out of stock
 * @param product - The product to check
 * @returns true if the product is out of stock, false otherwise
 */
export const isOutOfStock = (product: Product): boolean => {
  // Check if metadata.out_of_stock exists and is true
  // Also handle string "true" or "false" values
  const outOfStock = product.metadata?.out_of_stock;
  if (outOfStock === true || outOfStock === 'true') {
    return true;
  }
  return false;
};

export const createCheckoutSession = async (
  cartItems: CartItem[],
  successUrl?: string,
  cancelUrl?: string
): Promise<string> => {
  try {
    const baseUrl = window.location.origin;
    const finalSuccessUrl = successUrl || `${baseUrl}/checkout/success`;
    const finalCancelUrl = cancelUrl || `${baseUrl}/checkout/cancel`;

    const response = await fetch(getApiUrl('stripe_checkout.php'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        cartItems,
        successUrl: finalSuccessUrl,
        cancelUrl: finalCancelUrl
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.url || '';
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

export const retrieveCheckoutSession = async (sessionId: string) => {
  try {
    const response = await fetch(`${getApiUrl('stripe_session_retrieve.php')}?session_id=${sessionId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error retrieving checkout session:', error);
    throw error;
  }
};
